export default __webpack_public_path__ + "static/media/5.207ca776.jpg";